/* eslint-disable no-unused-vars */
import apiService from '@/utils/api-client'
import { featureAccess } from '@/utils/accesses'
import config from '@/utils/appConfig'
import store from '@/store'

export default {
  // eslint-disable-next-line no-unused-vars
  async getAiByReport({ commit }, payload) {
    try {
      return apiService.post(
        '/ai/report/assess/transaction',
        { ...payload },
        { baseURL: config.VUE_APP_API_3D_INTEGRATIONS },
      )
    } catch (error) {
      console.error(error)
    } finally {
      await store.dispatch('user/getMe')
    }
  },
  async getAiAssessment({ commit }, { params }) {
    try {
      return apiService.get('/ai-assessment/assess', {
        params,
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    } finally {
      await store.dispatch('user/getMe')
    }
  },
}
